import { getGoToBrandReferralsCTA } from "./shared";
export var BrandReferralStatusIA = function BrandReferralStatusIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_STATUS_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_STATUS_DESCRIPTION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToBrandReferral;
        return (_getGoToBrandReferral = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral === void 0 ? void 0 : _getGoToBrandReferral.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToBrandReferral2, _getGoToBrandReferral3;
        return (_getGoToBrandReferral2 = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral2 === void 0 ? void 0 : (_getGoToBrandReferral3 = _getGoToBrandReferral2.getLink) === null || _getGoToBrandReferral3 === void 0 ? void 0 : _getGoToBrandReferral3.call(_getGoToBrandReferral2);
      }
    }
  };
};
var BRAND_REFERRALS_STATUS_TITLE = function BRAND_REFERRALS_STATUS_TITLE(strictLocalize) {
  return strictLocalize({
    id: "MBTd1t",
    defaultMessage: [{
      "type": 0,
      "value": "Hoe je de status van merkdoorverwijzingen kunt bekijken"
    }]
  });
};
var BRAND_REFERRALS_STATUS_DESCRIPTION = function BRAND_REFERRALS_STATUS_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "HhHXze",
    defaultMessage: [{
      "type": 0,
      "value": "Ga naar ‘Merken doorverwijzen’ in ‘Account’ en selecteer het tabblad ‘Uitgenodigd’ om de status van de aanvraag van een merk te bekijken. Houd er rekening mee dat we alleen aanvullende informatie over de toepassing van een merk rechtstreeks met het merk zelf kunnen delen."
    }]
  });
};